import * as yup from "yup";

import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

const schema = yup.object({
  step: yup.number(),
  operation: yup.string(),
  result: yup.string(),
  details: yup.string(),
});

addKeyToFieldsRecursively(schema);

export default schema;
